"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionTypes = void 0;
const ActionTypes = exports.ActionTypes = {
  GET_BUSINESSENTITIES: 'GET_BUSINESSENTITIES',
  GET_USER_DETAILS: 'GET_USER_DETAILS',
  GET_ROLES_FOR_APP: 'GET_ROLES_FOR_APP',
  UPDATE_USER_ROLE: 'UPDATE_USER_ROLE',
  GET_USERS_FOR_ROLE: 'GET_USERS_FOR_ROLE',
  REMOVE_ACCESS: 'Remove Access',
  SEND_INVITATION_STATE: 'Send Invitation State',
  GET_MINESITES: 'GET_MINESITES',
  GET_USERACTIVITIES: 'GET_USERACTIVITIES',
  SET_APP_ID: 'SET_APP_ID',
  GET_ASSIGNABLE_USERS: 'GET_ASSIGNABLE_USERS',
  SET_ASSIGNABLE_USERS: 'SET_ASSIGNABLE_USERS',
  FETCH_MINE_SITE_INFO_SUCCESS: 'FETCH_MINE_SITE_INFO_SUCCESS',
  FETCH_MINE_SITE_INFO_FAILURE: 'FETCH_MINE_SITE_INFO_FAILURE',
  UPDATE_API_CALL_PROGRESS: 'UPDATE_API_CALL_PROGRESS',
  SAVE_PENDING_ACCESS_REQUESTS: 'SAVE_PENDING_ACCESS_REQUESTS',
  SAVE_ACCESS_REQUEST_ROLES: 'SAVE_ACCESS_REQUEST_ROLES',
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  HIDE_NOTIFICATION: 'HIDE_NOTIFICATION',
  SAVE_APPLICATION_BUSINESS_ENTITIES: 'SAVE_APPLICATION_BUSINESS_ENTITIES',
  SAVE_MINE_SITE_LABEL: 'SAVE_MINE_SITE_LABEL'
};